import { render, staticRenderFns } from "./ModalSuprimentosAguardandoCotacao.vue?vue&type=template&id=1b2525a2&scoped=true"
import script from "./ModalSuprimentosAguardandoCotacao.vue?vue&type=script&lang=ts"
export * from "./ModalSuprimentosAguardandoCotacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuprimentosAguardandoCotacao.vue?vue&type=style&index=0&id=1b2525a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2525a2",
  null
  
)

export default component.exports